import React, {Component} from 'react';
import Paper from 'material-ui/Paper';
import Form from '../../components/Forms/Form.jsx';
import Input from '../../components/Forms/Input2.jsx';
import MenuItem from 'material-ui/MenuItem';
import AutoComplete from 'material-ui/AutoComplete';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import Toggle from 'material-ui/Toggle';
import _ from 'underscore';

class RetIslrForm extends Component {
    render() {
        if (this.props.retislr === null) return null;
        let items = [];
        this.props.tipos_retencion.map((item, index) => {
            items[index] = {};
            items[index].text = item.codigo + ' - '+ item.descripcion;
            items[index].value = item.codigo + ' - '+ item.descripcion;
        });

        let retValidation = this.props.retislr.proveedor.tipo_proveedor === 'PND'
            ? "required,not_zero,ret_pn"
            : "requried,not_zero";

        return (
            <Paper style={{marginTop: 15, padding: '5px 20px 20px 20px'}}>
                <Form submitButton={true} onSubmit={this.props.onSubmit}>

                    <Input
                        outerClassName="col-xs-6"
                        validations="required"
                        val={this.props.retislr.numero}
                        onChange={this.props.onChange}
                        name="numero"
                        floatingLabelText="Número de Retención"
                        />

                    <Input
                        outerClassName="col-xs-6"
                        onChange={this.props.onChange}
                        tipo='date'
                        val={this.props.retislr.fecha_retencion}
                        validations="required"
                        name="fecha_retencion"
                        floatingLabelText="Fecha Retención"
                        locale={navigator.language}
                        DateTimeFormat={Intl.DateTimeFormat}
                        formatDate={Date.vzla}
                        />

                    <div className="col-xs-12" style={{marginTop: 20, marginBottom: 20}}>
                        <label htmlFor="tipo">Tipo de Documento</label>
                         <RadioButtonGroup
                            name="tipo_documento"
                            onChange={this.props.onChange}
                            defaultSelected="01"
                            value={this.props.retislr.tipo_documento}>

                            <RadioButton
                                value="01"
                                label="Factura"
                                style={{display:'inline-block'}}
                            />

                            <RadioButton
                                value="02"
                                label="Nota de Débito"
                                style={{display:'inline-block'}}
                            />

                            <RadioButton
                                value="03"
                                label="Nota de Crédito"
                                style={{display:'inline-block'}}
                            />
                         </RadioButtonGroup>
                    </div>

                    <div className="col-xs-12">
                        <Toggle
                          labelPosition="right"
                          defaultToggled={false}
                          toggled={this.props.sendMail}
                          onToggle={this.props.toggleMail}
                          label="Enviar por correo"
                          style={{margin:'12px 0px 0px 8px'}}
                        />
                    </div>

                    <Input
                        outerClassName="col-xs-12"
                        validations="required"
                        val={this.props.retislr.numero_documento}
                        onChange={this.props.onChange}
                        name="numero_documento"
                        floatingLabelText="Número de Documento"
                        />

                    <Input
                        outerClassName="col-xs-12"
                        validations="required"
                        val={this.props.retislr.numero_control}
                        onChange={this.props.onChange}
                        name="numero_control"
                        floatingLabelText="Número de Control"
                        />

                    <Input
                        outerClassName="col-xs-12"
                        onChange={this.props.onChange}
                        tipo='date'
                        val={this.props.retislr.fecha_documento}
                        validations="required"
                        name="fecha_documento"
                        floatingLabelText="Fecha Documento"
                        locale={navigator.language}
                        DateTimeFormat={Intl.DateTimeFormat}
                        formatDate={Date.vzla}
                        />

                    <Input
                        outerClassName="col-xs-12"
                        validations={retValidation}
                        val={parseFloat(this.props.retislr.base_retencion).fmtd()}
                        editVal={this.props.retislr.base_retencion}
                        onChange={this.props.onChange}
                        name="base_retencion"
                        currency={true}
                        floatingLabelText="Base Retención"
                        />

                    <Input
                        tipo="select"
                        fullWidth={true}
                        outerClassName="col-xs-12"
                        name="codigo_retencion"
                        onChange={this.props.onChange}
                        validations="required"
                        items={this.props.tipos_retencion}
                        val={this.props.retislr.codigo_retencion}
                        floatingLabelText="Tipo de Retención"
                        floatingLabelStyle={{zIndex:0}}

                        />

                        <Input
                        fullWidth={true}
                        outerClassName="col-xs-12"
                        name="porcentaje_retencion"
                        onChange={this.props.onChange}
                        validations="required"
                        val={(parseFloat(this.props.retislr.porcentaje_retencion)).fmtd()}
                        editVal={this.props.retislr.porcentaje_retencion}
                        currency={true}
                        floatingLabelText="Porcentaje a Retener"
                        />

                        <Input
                        hide={this.props.retislr.proveedor.tipo_proveedor !== 'PND'}
                        fullWidth={true}
                        outerClassName="col-xs-6"
                        name="sustraendo"
                        disabled={true}
                        val={parseFloat(this.props.retislr.sustraendo()).fmtd()}
                        floatingLabelText="Sustraendo"
                        />

                        <Input
                        fullWidth={true}
                        outerClassName="col-xs-12"
                        name="retencion"
                        disabled={true}
                        val={parseFloat(this.props.retislr.retencion()).fmtd()}
                        floatingLabelText="Monto Retención"
                        />

                        <Input
                        fullWidth={true}
                        outerClassName="col-xs-12"
                        name="descripcion"
                        onChange={this.props.onChange}
                        val={this.props.retislr.descripcion}
                        floatingLabelText="Descripción"
                        />

                </Form>

            </Paper>
        );
    }
}

export default RetIslrForm;



/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/RetIslrForm.jsx
 **/